import { FormState } from '../types'

export const initialFormState: FormState = {
  borrowerName: 'John Doe',
  loanNumber: '100293847',
  loanOfficer: 'Sarah Jenkins',
  loanOfficerEmail: 'sjenkins@madisonmortgage.com',
  loaEmail: 'loa@madisonmortgage.com',
  lender: 'UWM',
  disclosureStatus: 'Not Started',

  borrowerFirstName: 'John',
  borrowerMiddleName: '',
  borrowerLastName: 'Doe',
  borrowerEmail: 'john.doe@example.com',
  borrowerMobile: '555-019-2834',
  preferredContactLanguage: 'English',
  preferredContactMethod: 'Email',

  propertyStreet: '123 Main St',
  propertyState: 'NY',
  propertyType: 'Single Family',
  loanPurpose: 'Purchase',
  madisonECD: '2026-07-15',
  madisonECDCertified: false,
  appraisalCompanyName: 'Class Valuation',

  referredBy: 'Realtor',
  titleCompanyName: 'First American Title',
  settlementAgent: 'Jane Smith',
  hoiProvider: 'State Farm',
  buyerAgent: 'Mike Johnson',
  listingAgent: 'Emily Davis',
  buyerAgentEmail: 'mike@realty.com',
  buyerAgentMobile: '555-111-2222',
  listingAgentEmail: 'emily@realty.com',
  listingAgentMobile: '555-333-4444',
  buyerAgentLicense: 'LIC12345',
  listingAgentLicense: 'LIC67890',
  buyerBrokerLicense: 'BROK123',
  listingBrokerLicense: 'BROK456',
  buyerAttorney: '',
  sellerAttorney: '',
  hoaContact: '',

  qmType: 'QM',
  nonQmProductType: '',
  dscrRatio: '',
  processingType: 'Full-Service Processing',

  closingType: 'In-Person',
  newDeedRequired: 'No',
  lockAtDisclosure: 'Yes',
  lockPeriod: '30 Days',
  customLockPeriod: '',
  originatorCompType: 'Lender Paid',
  compensationFrontBackYSP: 'No',
  originationFeePercent: '',
  discountFeePercent: '',
  waiveUnderwritingFee: 'No',
  newConstruction: 'No',
  buyerPayingSellerTransferTax: 'No',
  transferTaxAmount: '',
  mortgageCommitmentDue: '2026-07-01',
  prePaymentPenalty: 'No',
  prePaymentPenaltyDuration: '',
  channel: 'Broker',
  designatedLender: 'UWM',
  borrowerApprovedCashAtClosing: 'Yes',
  paystubsIn60Days: 'Yes',
  utilizingFutureIncome: 'No',
  clearlyValidatedOfferLetter: 'No',
  borrowersEmployedByFamily: 'No',
  twoYearsTaxReturns: 'Yes',
  appraisalWaiverRequested: 'No',
  buyerPayingRealtorCommission: 'No',
  realtorCommission: '',
  escrowAccount: 'Yes',
  loanSource: 'Self-Generated',
  boardedWithLender: 'Yes',
  confirmLenderLoanNumber: '99887766',

  roadmapNotes: '',
  appraisalNotes: '',
  incomeNotes: '',
  assetNotes: '',
  creditNotes: '',

  disclosureRequestDatePopulated: false,
  loLicensedInState: true,
  ausFindingsCertified: true,
  lePricingReviewPreferenceSelected: true,
}

export const nonQmProductTypes = [
  { label: '1099: 12 Mo.', value: '1099: 12 Mo.' },
  { label: '1099: 24 Mo.', value: '1099: 24 Mo.' },
  {
    label: '12 Mo. PnL w/ Bank Statement',
    value: '12 Mo. PnL w/ Bank Statement',
  },
  {
    label: '24 Mo. PnL w/ Bank Statements',
    value: '24 Mo. PnL w/ Bank Statements',
  },
  {
    label: 'Asset Depletion / Utilization',
    value: 'Asset Depletion / Utilization',
  },
  {
    label: 'Bank Stmts: 12 Mo. Business',
    value: 'Bank Stmts: 12 Mo. Business',
  },
  {
    label: 'Bank Stmts: 12 Mo. Personal',
    value: 'Bank Stmts: 12 Mo. Personal',
  },
  {
    label: 'Bank Stmts: 24 Mo. Business',
    value: 'Bank Stmts: 24 Mo. Business',
  },
  {
    label: 'Bank Stmts: 24 Mo. Personal',
    value: 'Bank Stmts: 24 Mo. Personal',
  },
  { label: 'DSCR / No Ratio DSCR', value: 'DSCR / No Ratio DSCR' },
  { label: 'Full Doc: 1 Year Limited', value: 'Full Doc: 1 Year Limited' },
  { label: 'Full Doc 2 Year', value: 'Full Doc 2 Year' },
  {
    label: 'No Income / No Employment / No DTI',
    value: 'No Income / No Employment / No DTI',
  },
  { label: 'PnL: 12 Mo. CPA Prepared', value: 'PnL: 12 Mo. CPA Prepared' },
  { label: 'PnL: 24 Mo. CPA Prepared', value: 'PnL: 24 Mo. CPA Prepared' },
  { label: 'WVOE', value: 'WVOE' },
]

export const processingTypes = [
  { label: 'Full-Service Processing', value: 'Full-Service Processing' },
  { label: 'Disclosure & Opening Only', value: 'Disclosure & Opening Only' },
  {
    label: 'No Borrower Contact Processing',
    value: 'No Borrower Contact Processing',
  },
]

export const usStates = [
  { label: 'Alabama (AL)', value: 'AL' },
  { label: 'Alaska (AK)', value: 'AK' },
  { label: 'Arizona (AZ)', value: 'AZ' },
  { label: 'Arkansas (AR)', value: 'AR' },
  { label: 'California (CA)', value: 'CA' },
  { label: 'Colorado (CO)', value: 'CO' },
  { label: 'Connecticut (CT)', value: 'CT' },
  { label: 'Delaware (DE)', value: 'DE' },
  { label: 'Florida (FL)', value: 'FL' },
  { label: 'Georgia (GA)', value: 'GA' },
  { label: 'Hawaii (HI)', value: 'HI' },
  { label: 'Idaho (ID)', value: 'ID' },
  { label: 'Illinois (IL)', value: 'IL' },
  { label: 'Indiana (IN)', value: 'IN' },
  { label: 'Iowa (IA)', value: 'IA' },
  { label: 'Kansas (KS)', value: 'KS' },
  { label: 'Kentucky (KY)', value: 'KY' },
  { label: 'Louisiana (LA)', value: 'LA' },
  { label: 'Maine (ME)', value: 'ME' },
  { label: 'Maryland (MD)', value: 'MD' },
  { label: 'Massachusetts (MA)', value: 'MA' },
  { label: 'Michigan (MI)', value: 'MI' },
  { label: 'Minnesota (MN)', value: 'MN' },
  { label: 'Mississippi (MS)', value: 'MS' },
  { label: 'Missouri (MO)', value: 'MO' },
  { label: 'Montana (MT)', value: 'MT' },
  { label: 'Nebraska (NE)', value: 'NE' },
  { label: 'Nevada (NV)', value: 'NV' },
  { label: 'New Hampshire (NH)', value: 'NH' },
  { label: 'New Jersey (NJ)', value: 'NJ' },
  { label: 'New Mexico (NM)', value: 'NM' },
  { label: 'New York (NY)', value: 'NY' },
  { label: 'North Carolina (NC)', value: 'NC' },
  { label: 'North Dakota (ND)', value: 'ND' },
  { label: 'Ohio (OH)', value: 'OH' },
  { label: 'Oklahoma (OK)', value: 'OK' },
  { label: 'Oregon (OR)', value: 'OR' },
  { label: 'Pennsylvania (PA)', value: 'PA' },
  { label: 'Rhode Island (RI)', value: 'RI' },
  { label: 'South Carolina (SC)', value: 'SC' },
  { label: 'South Dakota (SD)', value: 'SD' },
  { label: 'Tennessee (TN)', value: 'TN' },
  { label: 'Texas (TX)', value: 'TX' },
  { label: 'Utah (UT)', value: 'UT' },
  { label: 'Vermont (VT)', value: 'VT' },
  { label: 'Virginia (VA)', value: 'VA' },
  { label: 'Washington (WA)', value: 'WA' },
  { label: 'West Virginia (WV)', value: 'WV' },
  { label: 'Wisconsin (WI)', value: 'WI' },
  { label: 'Wyoming (WY)', value: 'WY' },
]

export interface DirectoryContact {
  id: string
  name: string
  category:
    | 'Referral'
    | 'Title'
    | 'Settlement'
    | 'HOI'
    | 'Agent'
    | 'Appraisal'
    | 'Attorney'
  subtitle: string
}

export const contactDirectory: DirectoryContact[] = [
  // Referral sources
  {
    id: 'ref-1',
    name: 'Coldwell Banker Realty',
    category: 'Referral',
    subtitle: 'Real Estate Brokerage',
  },
  {
    id: 'ref-2',
    name: 'Keller Williams',
    category: 'Referral',
    subtitle: 'Real Estate Brokerage',
  },
  {
    id: 'ref-3',
    name: 'RE/MAX Premier',
    category: 'Referral',
    subtitle: 'Real Estate Brokerage',
  },
  {
    id: 'ref-4',
    name: 'Past Client Referral',
    category: 'Referral',
    subtitle: 'Borrower Referral',
  },
  {
    id: 'ref-5',
    name: 'Compass',
    category: 'Referral',
    subtitle: 'Real Estate Brokerage',
  },
  // Title companies
  {
    id: 'title-1',
    name: 'First American Title',
    category: 'Title',
    subtitle: 'Title Company · Nationwide',
  },
  {
    id: 'title-2',
    name: 'Fidelity National Title',
    category: 'Title',
    subtitle: 'Title Company · Nationwide',
  },
  {
    id: 'title-3',
    name: 'Old Republic Title',
    category: 'Title',
    subtitle: 'Title Company · Nationwide',
  },
  {
    id: 'title-4',
    name: 'Chicago Title',
    category: 'Title',
    subtitle: 'Title Company · Nationwide',
  },
  {
    id: 'title-5',
    name: 'Stewart Title',
    category: 'Title',
    subtitle: 'Title Company · Nationwide',
  },
  // Settlement agents
  {
    id: 'sett-1',
    name: 'Jane Smith',
    category: 'Settlement',
    subtitle: 'Settlement Agent · First American',
  },
  {
    id: 'sett-2',
    name: 'Robert Chen',
    category: 'Settlement',
    subtitle: 'Settlement Agent · Fidelity National',
  },
  {
    id: 'sett-3',
    name: 'Maria Gonzalez',
    category: 'Settlement',
    subtitle: 'Settlement Agent · Old Republic',
  },
  {
    id: 'sett-4',
    name: 'David Park',
    category: 'Settlement',
    subtitle: 'Closing Attorney · Park & Assoc.',
  },
  // HOI providers
  {
    id: 'hoi-1',
    name: 'State Farm',
    category: 'HOI',
    subtitle: 'Homeowners Insurance',
  },
  {
    id: 'hoi-2',
    name: 'Allstate',
    category: 'HOI',
    subtitle: 'Homeowners Insurance',
  },
  {
    id: 'hoi-3',
    name: 'Liberty Mutual',
    category: 'HOI',
    subtitle: 'Homeowners Insurance',
  },
  {
    id: 'hoi-4',
    name: 'Travelers',
    category: 'HOI',
    subtitle: 'Homeowners Insurance',
  },
  {
    id: 'hoi-5',
    name: 'Lemonade',
    category: 'HOI',
    subtitle: 'Homeowners Insurance',
  },
  {
    id: 'agt-1',
    name: 'Mike Johnson',
    category: 'Agent',
    subtitle: 'Coldwell Banker · Lic #LIC12345',
  },
  {
    id: 'agt-2',
    name: 'Emily Davis',
    category: 'Agent',
    subtitle: 'Keller Williams · Lic #LIC67890',
  },
  {
    id: 'agt-3',
    name: 'Carlos Rivera',
    category: 'Agent',
    subtitle: 'RE/MAX Premier · Lic #LIC22334',
  },
  {
    id: 'agt-4',
    name: 'Sandra Lee',
    category: 'Agent',
    subtitle: 'Compass · Lic #LIC44556',
  },
  {
    id: 'agt-5',
    name: 'Thomas Wright',
    category: 'Agent',
    subtitle: 'Coldwell Banker · Lic #LIC55667',
  },
  {
    id: 'app-1',
    name: 'Class Valuation',
    category: 'Appraisal',
    subtitle: 'Appraisal Management Company',
  },
  {
    id: 'app-2',
    name: 'Clear Capital',
    category: 'Appraisal',
    subtitle: 'Appraisal Management Company',
  },
  {
    id: 'app-3',
    name: 'Solidifi',
    category: 'Appraisal',
    subtitle: 'Appraisal Management Company',
  },
  {
    id: 'app-4',
    name: 'ServiceLink',
    category: 'Appraisal',
    subtitle: 'Appraisal Management Company',
  },
  {
    id: 'app-5',
    name: 'Nationwide Appraisal Network',
    category: 'Appraisal',
    subtitle: 'Appraisal Management Company',
  },
  {
    id: 'atty-1',
    name: 'Goldstein & Associates',
    category: 'Attorney',
    subtitle: 'Real Estate Attorney',
  },
  {
    id: 'atty-2',
    name: 'Patel Law Group',
    category: 'Attorney',
    subtitle: 'Real Estate Attorney',
  },
  {
    id: 'atty-3',
    name: 'Sullivan & Cromwell',
    category: 'Attorney',
    subtitle: 'Real Estate Attorney',
  },
  {
    id: 'atty-4',
    name: 'Ramirez Title Law',
    category: 'Attorney',
    subtitle: 'Closing Attorney',
  },
  {
    id: 'atty-5',
    name: 'Chen Real Estate Law',
    category: 'Attorney',
    subtitle: 'Real Estate Attorney',
  },
]

export const propertyTypes = [
  { label: 'Single Family', value: 'Single Family' },
  { label: 'Multi Family', value: 'Multi Family' },
  { label: 'Condo', value: 'Condo' },
  { label: 'Co-op', value: 'Co-op' },
  { label: 'High-Rise Condo', value: 'High-Rise Condo' },
  { label: 'Detached Condo', value: 'Detached Condo' },
  { label: 'Townhouse', value: 'Townhouse' },
]

export const yesNoOptions = [
  { label: 'Yes', value: 'Yes' },
  { label: 'No', value: 'No' },
]
